'use client';
import { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation as useTranslationClient } from '@/lib/i18n/i18n.client';
import { fallbackLng } from '@/lib/i18n/settings';

const LanguageContext = createContext();

export const useTranslation = (overrideNS, options) => {
  const { lng, ns } = useContext(LanguageContext);
  return useTranslationClient(lng, overrideNS || ns, options);
};

export const useLanguage = () => useContext(LanguageContext);

// Set the language once on load so it doesn't override the user's choice after
export const useInitialLanguage = (initialLng) => {
  const { lng, changeLanguage } = useTranslation();
  const [loadLngSet, setLoadLngSet] = useState(false);

  useEffect(() => {
    setLoadLngSet(true);
    if (!loadLngSet && initialLng && initialLng !== lng) {
      changeLanguage(initialLng);
    }
  }, [loadLngSet, lng, initialLng]);
};

export default function LanguageProvider({ defaultLng, ns: propNs, children }) {
  const { lng: parentLng, ns: parentNs } = useLanguage() || {};
  const lng = parentLng || defaultLng || fallbackLng;
  const ns = propNs || parentNs;
  return (
    <LanguageContext.Provider value={{ lng, ns }}>
      {children}
    </LanguageContext.Provider>
  );
}
